import e, { Component as t } from "react";
import o from "../../../../node_modules/classnames/index.js";
import r from "../../../utils/DomHandler.js";
import n from "../../../utils/ObjectUtils.js";
import { isSpacebar as l } from "../../../constants/keyboard.js";
import { Icon as s } from "../Icon/Icon.js";
import a from "./BulkActionsDropdown.js";
import { CheckBox as i } from "../../forms/Checkbox/Checkbox.js";
function u(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function c(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function m(e) {
  return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function h(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {},
      r = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), r.forEach(function (t) {
      c(e, t, o[t]);
    });
  }
  return e;
}
function d(e, t) {
  return (d = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var b = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && d(e, t);
  }(C, t);
  var b,
    f,
    g,
    v = (b = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        o = m(C);
      if (b) {
        var r = m(this).constructor;
        t = Reflect.construct(o, arguments, r);
      } else t = o.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : u(this);
    });
  function C() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, C), e = v.apply(this, arguments), c(u(e), "state", {
      styleObject: {}
    }), c(u(e), "el", void 0), c(u(e), "onClick", function (t) {
      if (!e.isSortableDisabled()) {
        var o = t.target;
        (r.hasClass(o, "datatable__column--sortable") || r.hasClass(o, "datatable__column-title") || r.hasClass(o, "datatable__column-header-content") || r.hasClass(o, "datatable__column-sort") || r.hasClass(o.parentElement, "datatable__column-sort")) && (r.clearSelection(), e.props.onSortChange({
          originalEvent: t,
          column: e.props.column,
          sortableDisabledFields: e.props.sortableDisabledFields
        }));
      }
    }), c(u(e), "onMouseDown", function (t) {
      e.props.onColumnMouseDown({
        originalEvent: t,
        column: e.props.column
      });
    }), c(u(e), "onKeyDown", function (t) {
      "Enter" === t.key && t.currentTarget === e.el && r.hasClass(t.currentTarget, "datatable__column--sortable") && (e.onClick(t), t.preventDefault());
    }), c(u(e), "onDragStart", function (t) {
      e.props.onColumnDragStart({
        originalEvent: t,
        column: e.props.column
      });
    }), c(u(e), "onDragOver", function (t) {
      e.props.onColumnDragOver({
        originalEvent: t,
        column: e.props.column
      });
    }), c(u(e), "onDragLeave", function (t) {
      e.props.onColumnDragLeave({
        originalEvent: t,
        column: e.props.column
      });
    }), c(u(e), "onDrop", function (t) {
      e.props.onColumnDrop({
        originalEvent: t,
        column: e.props.column
      });
    }), c(u(e), "onResizerMouseDown", function (t) {
      e.props.onColumnResizeStart({
        originalEvent: t,
        column: e.props.column
      });
    }), c(u(e), "onResizerClick", function (t) {
      e.props.onColumnResizerClick && (e.props.onColumnResizerClick({
        originalEvent: t,
        element: t.currentTarget.parentElement,
        column: e.props.column
      }), t.preventDefault());
    }), c(u(e), "onResizerDoubleClick", function (t) {
      e.props.onColumnResizerDoubleClick && (e.props.onColumnResizerDoubleClick({
        originalEvent: t,
        element: t.currentTarget.parentElement,
        column: e.props.column
      }), t.preventDefault());
    }), c(u(e), "onColumnCheckboxChange", function (t, o) {
      var r = e.props.allRowsSelected(e.props.value);
      e.props.onColumnCheckboxChange({
        originalEvent: o,
        checked: r
      });
    }), c(u(e), "onColumnCheckboxKeyDown", function (t) {
      var o = e.props.allRowsSelected(e.props.value);
      l(t) && (e.props.onColumnCheckboxChange({
        originalEvent: t,
        checked: o
      }), t.preventDefault());
    }), e;
  }
  return f = [{
    key: "isBadgeVisible",
    value: function value() {
      return this.props.multiSortMeta && this.props.multiSortMeta.length > 1;
    }
  }, {
    key: "isSortableDisabled",
    value: function value() {
      return !this.getColumnProp("sortable") || this.getColumnProp("sortable") && (this.props.allSortableDisabled || this.getColumnProp("sortableDisabled"));
    }
  }, {
    key: "getColumnProp",
    value: function value() {
      for (var e = arguments.length, t = Array(e), o = 0; o < e; o++) t[o] = arguments[o];
      return this.props.column ? "string" == typeof t[0] ? this.props.column.props[t[0]] : (t[0] || this.props.column).props[t[1]] : null;
    }
  }, {
    key: "getStyle",
    value: function value() {
      var e = this.getColumnProp("headerStyle"),
        t = this.getColumnProp("style");
      return this.getColumnProp("frozen") ? Object.assign({}, t, e, this.state.styleObject) : Object.assign({}, t, e);
    }
  }, {
    key: "getMultiSortMetaIndex",
    value: function value() {
      var e = this;
      return this.props.multiSortMeta.findIndex(function (t) {
        return t.field === e.getColumnProp("field") || t.field === e.getColumnProp("sortField");
      });
    }
  }, {
    key: "getSortMeta",
    value: function value() {
      var e = !1,
        t = 0,
        o = -1;
      return "single" === this.props.sortMode ? t = (e = this.props.sortField && (this.props.sortField === this.getColumnProp("field") || this.props.sortField === this.getColumnProp("sortField"))) ? this.props.sortOrder : 0 : "multiple" === this.props.sortMode && (o = this.getMultiSortMetaIndex()) > -1 && (e = !0, t = this.props.multiSortMeta[o].order), {
        sorted: e,
        sortOrder: t,
        metaIndex: o
      };
    }
  }, {
    key: "getAriaSort",
    value: function value(e) {
      var t = e.sorted,
        o = e.sortOrder;
      if (this.getColumnProp("sortable")) {
        var r = t ? o < 0 ? "pi-sort-amount-down" : "pi-sort-amount-up-alt" : "pi-sort-alt";
        return "pi-sort-amount-down" === r ? "descending" : "pi-sort-amount-up-alt" === r ? "ascending" : "none";
      }
      return null;
    }
  }, {
    key: "updateStickyPosition",
    value: function value() {
      if (this.getColumnProp("frozen")) {
        var e = h({}, this.state.styleObject);
        if ("right" === this.getColumnProp("alignFrozen")) {
          var t = 0,
            o = this.el.nextElementSibling;
          o && (t = r.getOuterWidth(o) + parseFloat(o.style.right || 0)), e.right = t + "px";
        } else {
          var n,
            l = 0,
            s = null === (n = this.el) || void 0 === n ? void 0 : n.previousElementSibling;
          s && (l = r.getOuterWidth(s) + parseFloat(s.style.left || 0)), e.left = l + "px";
        }
        var a = this.el.parentElement.nextElementSibling;
        if (a) {
          var i = r.index(this.el);
          a.children[i].style.left = e.left, a.children[i].style.right = e.right;
        }
        this.state.styleObject.left === e.left && this.state.styleObject.right === e.right || this.setState({
          styleObject: e
        });
      }
    }
  }, {
    key: "updateSortableDisabled",
    value: function value(e) {
      (this.getColumnProp(e, "sortableDisabled") !== this.getColumnProp("sortableDisabled") || this.getColumnProp(e, "sortable") !== this.getColumnProp("sortable")) && this.props.onSortableChange();
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.getColumnProp("frozen") && this.updateStickyPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this.getColumnProp("frozen") && this.updateStickyPosition(), this.updateSortableDisabled(e.column);
    }
  }, {
    key: "renderResizer",
    value: function value() {
      return this.props.resizableColumns && !this.getColumnProp("frozen") ? e.createElement("span", {
        className: "datatable__column-resizer",
        onMouseDown: this.onResizerMouseDown,
        onClick: this.onResizerClick,
        onDoubleClick: this.onResizerDoubleClick
      }) : null;
    }
  }, {
    key: "renderTitle",
    value: function value() {
      var t = n.getJSXElement(this.getColumnProp("header"), {
        props: this.props.tableProps
      });
      return e.createElement("span", {
        className: "datatable__column-title"
      }, t);
    }
  }, {
    key: "renderSort",
    value: function value(t) {
      var r = t.sortOrder;
      if (this.getColumnProp("sortable")) {
        var n = "datatable__column-sort-icon--active";
        return e.createElement("div", {
          className: "datatable__column-sort"
        }, e.createElement(s, {
          name: "caret-up",
          solid: !0,
          className: o("datatable__column-sort-icon--asc", r > 0 && n)
        }), e.createElement(s, {
          name: "caret-down",
          solid: !0,
          className: o("datatable__column-sort-icon--desc", r < 0 && n)
        }));
      }
      return null;
    }
  }, {
    key: "renderBadge",
    value: function value(t) {
      var o = t.metaIndex;
      if (-1 !== o && this.isBadgeVisible()) {
        var r = this.props.groupRowsBy && this.props.groupRowsBy === this.props.groupRowSortField ? o : o + 1;
        return e.createElement("span", {
          className: "datatable__column-sort-badge"
        }, r);
      }
      return null;
    }
  }, {
    key: "renderCheckbox",
    value: function value() {
      if ("multiple" === this.getColumnProp("selectionMode") && "row" !== this.props.filterDisplay) {
        var t,
          o,
          r,
          n,
          l,
          s,
          u = this.props.allRowsSelected(this.props.value),
          p = (null === (n = this.props.tableProps) || void 0 === n ? void 0 : null === (r = n.selection) || void 0 === r ? void 0 : r.length) > 0,
          c = e.createElement(i, {
            className: "datatable__checkbox",
            name: "".concat(this.props.tableSelector, "header-checkbox"),
            value: u || !!p && "mixed",
            disabled: this.props.empty,
            onKeyDown: this.onColumnCheckboxKeyDown,
            onChange: this.onColumnCheckboxChange
          });
        return (null === (l = this.props.tableProps) || void 0 === l ? void 0 : l.bulkActionsDropdownProps) ? e.createElement(a, (t = h({}, this.props.tableProps.bulkActionsDropdownProps), o = o = {
          selectedItemsNum: null === (s = this.props.tableProps.selection) || void 0 === s ? void 0 : s.length
        }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : function (e, t) {
          var o = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            o.push.apply(o, r);
          }
          return o;
        }(Object(o)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
        }), t), c) : c;
      }
      return null;
    }
  }, {
    key: "renderHeader",
    value: function value(t) {
      var o = this.renderTitle(),
        r = this.renderSort(t),
        n = this.renderBadge(t),
        l = this.renderCheckbox();
      return e.createElement("div", {
        className: "datatable__column-header-content"
      }, o, r, n, l);
    }
  }, {
    key: "renderElement",
    value: function value() {
      var t = this,
        r = this.isSortableDisabled(),
        n = this.getSortMeta(),
        l = this.getStyle(),
        s = o("datatable__cell datatable__cell--head", this.getColumnProp("headerClassName"), this.getColumnProp("className"), {
          "datatable__column--sortable": this.getColumnProp("sortable"),
          "datatable__column--resizable": this.props.resizableColumns,
          "datatable__column--sorted": n.sorted,
          "datatable__column--frozen": this.getColumnProp("frozen"),
          "datatable__column--selectable": this.getColumnProp("selectionMode"),
          "datatable__column--row-editor": this.getColumnProp("rowEditor"),
          "datatable__column--sortable-disabled": this.getColumnProp("sortable") && r,
          "datatable__column--reorderable": this.props.reorderableColumns && this.getColumnProp("reorderable"),
          "datatable__column--row-reorder": this.getColumnProp("rowReorder")
        }),
        a = this.getColumnProp("sortable") && !r ? this.props.tabIndex : null,
        i = this.getColumnProp("colSpan"),
        u = this.getColumnProp("rowSpan"),
        p = this.getAriaSort(n),
        c = this.renderResizer(),
        m = this.renderHeader(n);
      return e.createElement("th", {
        ref: function ref(e) {
          return t.el = e;
        },
        style: l,
        className: s,
        tabIndex: a,
        role: "columnheader",
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        onMouseDown: this.onMouseDown,
        onDragStart: this.onDragStart,
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop,
        colSpan: i,
        rowSpan: u,
        "aria-sort": p
      }, c, m);
    }
  }, {
    key: "render",
    value: function value() {
      return this.renderElement();
    }
  }], p(C.prototype, f), g && p(C, g), C;
}(t);
export { b as HeaderCell };